import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-create-page',
  templateUrl: './create-page.component.html',
  styleUrls: ['./create-page.component.scss']
})
export class CreatePageComponent implements OnInit {
  public pagesForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) {}

  message = null;
  class = null;
  action = null;
  submitted = false;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/pagesbyid/' + `${id}`).subscribe(
        data => {
          console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.pagesForm.patchValue({
              _id: data.data._id,
              name: data.data.name,
              bannerimage: data.data.bannerimage,
              thumbnail: data.data.thumbnail,
              description: data.data.description,
              url: data.data.url,
              metatitle: data.data.metatitle,
              metadesc: data.data.metadesc,
              metatags: data.data.metatags,
              metakeyword: data.data.metakeyword,
              
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.pagesForm = this.formBuilder.group({
      name: ['', Validators.required],
      url: ['', Validators.required],
      bannerimage: ['', Validators.required],
      thumbnail: [''],
      description: [''],
      metakeyword: [''],
      metatags: [''],
      metatitle: [''],
      metadesc: [''],
      _id: ['']
    })
  }

  get f() { return this.pagesForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.pagesForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "name" : this.pagesForm.value.name,
      "bannerimage" : this.pagesForm.value.bannerimage,
      "url" : this.pagesForm.value.url,
      "thumbnail" : this.pagesForm.value.thumbnail,
      "description" : this.pagesForm.value.description,
      "metakeyword" : this.pagesForm.value.metakeyword,
      "metadesc" : this.pagesForm.value.metadesc,
      "metatags" : this.pagesForm.value.metatags,
      "metatitle" : this.pagesForm.value.metatitle,
      "admin" : sessionStorage.getItem('adminName'),
      };
    console.log(data);
    this.http.post<any>(this.api_endpoint+'/pages', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/pages/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "name" : this.pagesForm.value.name,
      "bannerimage" : this.pagesForm.value.bannerimage,
      "url" : this.pagesForm.value.url,
      "thumbnail" : this.pagesForm.value.thumbnail,
      "description" : this.pagesForm.value.description,
      "metakeyword" : this.pagesForm.value.metakeyword,
      "metadesc" : this.pagesForm.value.metadesc,
      "metatags" : this.pagesForm.value.metatags,
      "metatitle" : this.pagesForm.value.metatitle,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.pagesForm.value._id,
      };
      console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/pages/', data1).subscribe(
      res => {
      console.log(res);
      if(res.Error){
        this.message = res.Error;
        this.class = 'btn btn-primary';
        return
      }else{
        this.message = 'Successfully Added';
        this.class = 'btn btn-success';
      } 
      this.router.navigateByUrl('/adminhkbkcms/pages/list-page');
      },
      (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
      });
  }
  }

}
